/* eslint-disable max-len */
import {Grid, Step, StepLabel, Stepper} from '@material-ui/core';
import {autobind} from 'core-decorators';
import React, {Component, Fragment} from 'react';
import moment from 'moment';
import AddressGrid from 'components/address-grid';
import Button from 'components/button';
import {DateInput, Field, Form, Input, LocalitySelect, Textarea, TimeInput} from 'components/forms';
import {refundForm} from 'components/forms/decorators';
import {gt} from 'components/forms/form/validators';
import NewOptionsSidebar from 'components/new-options-sidebar';
import SectionBanner from 'components/section-banner';
import {reverse} from 'core/urls';
import {getDefaultAddress} from 'core/utils';
import createCLDealerKitsOrderMutation from 'graphql/mutations/orders/create-cl-dealer-kits-order.gql';
import styles from '../styles.css';

@refundForm(createCLDealerKitsOrderMutation, {loadAddresses: true})
@autobind
export default class CLDealerKitsCreate extends Component {
    state = {
        activeStep: 0,
    };

    getSteps() {
        return ['Fecha y horario', 'Establecimiento', 'Información Adicional', 'Envío'];
    }

    render() {
        const steps = this.getSteps();

        const handleNext = () => {
            this.setState({activeStep: this.state.activeStep + 1});
        };

        const handleBack = () => {
            this.setState({activeStep: this.state.activeStep - 1});
        };

        return (
            <div className={styles.root}>
                <SectionBanner />
                <NewOptionsSidebar
                    refundType='cl'
                    userType='dealer'
                    links={['refund', 'kits', 'trialSigns']}
                />
                <p className={styles.title}>Solicitud de Invitaciones y Kits</p>
                <p className={styles.subtitle}>Hacé el pedido de invitación y kits para convocar y recibir a tus invitados</p>
                <Stepper activeStep={this.state.activeStep} style={{px: 0}} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Form
                    fields={this.props.populateInitial([
                        {key: 'date'},
                        {key: 'time'},
                        {key: 'rsvpEmail', validators: ['email']},
                        {key: 'rsvpPhone', required: false},
                        {key: 'locationName'},
                        {key: 'locationLocality'},
                        {key: 'locationAddress'},
                        {key: 'topics', required: false},
                        {key: 'extraInfo', required: false},
                        {key: 'attendees', validators: [gt(0)]},
                        {key: 'notes', required: false},
                        {key: 'address', initial: getDefaultAddress(this.props.addressesData)},
                    ])}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid, values}) => {
                        return (
                            <Fragment>
                                {this.state.activeStep === 0 &&
                                <Grid container spacing={1}>
                                    <Grid item md={4} style={{alignSelf: 'end', position: 'relative'}}>
                                        <Field label='Fecha'>
                                            <DateInput min={moment().format('YYYY-MM-DD')} {...getFieldProps('date')} />
                                            <p style={{position: 'absolute'}}>{renderErrors('date')}</p>
                                        </Field>
                                    </Grid>
                                    <Grid item md={4} style={{alignSelf: 'end', position: 'relative'}}>
                                        <Field label='Hora'>
                                            <TimeInput {...getFieldProps('time')} />
                                            <p style={{position: 'absolute'}}>{renderErrors('time')}</p>
                                        </Field>
                                    </Grid>
                                    <Grid item container md={4} alignItems='flex-end'>
                                        <Grid item xs={12}>
                                            <Form.Actions>
                                                <Button
                                                    fullWidth
                                                    theme='yellow'
                                                    type='button'
                                                    onClick={handleNext}
                                                    disabled={values.date === '' || values.time === '' || renderErrors('time') || renderErrors('date')}
                                                >
                                                    Siguiente
                                                </Button>
                                            </Form.Actions>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                }
                                {this.state.activeStep === 1 &&
                                    <Grid container spacing={5}>
                                        <Grid item container spacing={1}>
                                            <Grid item md={4}>
                                                <Field label='Nombre del establecimiento' helptext='Nombre del establecimiento donde se realiza el campo líder.'>
                                                    <Input type='text' {...getFieldProps('locationName')} />
                                                    {renderErrors('locationName')}
                                                </Field>
                                            </Grid>
                                            <Grid item md={4}>
                                                <Field label='Localidad del establecimiento'>
                                                    <LocalitySelect {...this.props.getLocalitySelectProps(getFieldProps('locationLocality'))} />
                                                    {renderErrors('locationLocality')}
                                                </Field>
                                            </Grid>
                                            <Grid item md={4}>
                                                <Field label='Dirección del establecimiento' helptext='Dirección del establecimiento donde se realiza el campo líder. pueden incluir coordenadas GPS.'>
                                                    <Input type='text' {...getFieldProps('locationAddress')} />
                                                    {renderErrors('locationAddress')}
                                                </Field>
                                            </Grid>
                                            <Grid item md={4}>
                                                <Field label='Email de confirmación' helptext='Este email aparece en la invitación para que los invitados confirmen su asistencia.'>
                                                    <Input type='email' {...getFieldProps('rsvpEmail')} />
                                                    {renderErrors('rsvpEmail')}
                                                </Field>
                                            </Grid>
                                            <Grid item md={4}>
                                                <Field label='Teléfono de confirmación' helptext='Este teléfono aparece en la invitación para que los invitados confirmen su asistencia.'>
                                                    <Input type='number' {...getFieldProps('rsvpPhone')} />
                                                    {renderErrors('rsvpPhone')}
                                                </Field>
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={12} justify='space-between' alignItems='center'>
                                            <Grid item>
                                                <button type='button' style={{fontWeight: 600}} onClick={handleBack}>
                                                    Volver
                                                </button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button
                                                    fullWidth
                                                    theme='yellow'
                                                    type='button'
                                                    onClick={handleNext}
                                                    disabled={
                                                        values.rsvpEmail === '' ||
                                                        values.locationAddress === '' ||
                                                        values.locationName === '' ||
                                                        values.locationLocality === '' ||
                                                        renderErrors('rsvpPhone') ||
                                                        renderErrors('rsvpEmail') ||
                                                        renderErrors('locationAddress') ||
                                                        renderErrors('locationLocality') ||
                                                        renderErrors('locationName')
                                                    }
                                                >
                                                    Siguiente
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                {this.state.activeStep === 2 &&
                                    <Grid container spacing={5}>
                                        <Grid item container spacing={2}>
                                            <Grid item md={6}>
                                                <Field label='Temas y disertantes'>
                                                    <Textarea {...getFieldProps('topics')} />
                                                    {renderErrors('topics')}
                                                </Field>
                                            </Grid>
                                            <Grid item md={6}>
                                                <Field label='Información adicional para incluir en la invitación'>
                                                    <Textarea {...getFieldProps('extraInfo')} />
                                                    {renderErrors('extraInfo')}
                                                </Field>
                                            </Grid>
                                            <Grid item md={6}>
                                                <Field label='Comentarios para Nidera'>
                                                    <Textarea {...getFieldProps('notes')} />
                                                    {renderErrors('notes')}
                                                </Field>
                                            </Grid>
                                            <Grid item md={6}>
                                                <Field label='Cantidad de invitados'>
                                                    <Input type='number' {...getFieldProps('attendees')} />
                                                    {renderErrors('attendees')}
                                                </Field>
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={12} justify='space-between' alignItems='center'>
                                            <Grid item>
                                                <button type='button' style={{fontWeight: 600}} onClick={handleBack}>
                                                    Volver
                                                </button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button
                                                    fullWidth
                                                    theme='yellow'
                                                    type='button'
                                                    onClick={handleNext}
                                                    disabled={renderErrors('attendees') || values.attendees === ''}
                                                >
                                                    Siguiente
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                {this.state.activeStep === 3 &&
                                    <Grid container spacing={5}>
                                        <Grid item xs={12}>
                                            <Field label='Dirección de envío de los kits'>
                                                <AddressGrid
                                                    addresses={this.props.addressesData.addresses}
                                                    returnUrl={reverse('clDealerKitsCreate')}
                                                    returnData={values}
                                                    selectedAddress={values.address}
                                                    {...getFieldProps('address')} />
                                                {renderErrors('address')}
                                            </Field>
                                        </Grid>
                                        <Grid item>
                                            {renderErrors('__all__')}
                                        </Grid>
                                        <Grid item container xs={12} justify='space-between' alignItems='center'>
                                            <Grid item>
                                                <button type='button' style={{fontWeight: 600}} onClick={handleBack}>
                                                    Volver
                                                </button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button
                                                    disabled={!isValid() || this.props.loading}
                                                    fullWidth
                                                    theme='yellow'
                                                >
                                                    {this.props.loading ? 'Enviando...' : 'Enviar'}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                            </Fragment>
                        );
                    }}
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/cl-dealer/kits/index.js